import { get } from "@crunchit/http-client";
import { IProductionUnitDto } from "@crunchit/types";
import { getToken, getEnvironment } from "utils/helpers/service";

const api = process.env.REACT_APP_PRODUCTIONUNIT_URI || `productionunit.${getEnvironment()}crunchy.ninja/api`;

const ProductionUnitService = {
  getProductionUnits: async () => {
    return get<IProductionUnitDto[]>(`${api}/productionunit`, getToken());
  },
  getProductionUnitById: async (id: number) => {
    return get<IProductionUnitDto>(`${api}/productionunit/${id}`, getToken());
  },
  getNow: async (id: number) => {
    return get<string>(`${api}/productionunit/${id}/now`, getToken());
  },
};

export default ProductionUnitService;
